module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "操作说明",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v(" 企业ID:\n        每个企业都拥有唯一的corpid，获取此信息可在管理后台“我的企业”－“企业信息”下查看“企业ID”（需要有管理员权限）"), _c('br'), _vm._v("\n        获取通讯录管理secret的方法如下：\n        1、进入企业微信管理后台，在“管理工具” — “通讯录同步”开启“API接口同步”\n        2、开启后，可设置通讯录API的权限：读取或者编辑通讯录\n        3、使用通讯录同步的secret进行开发\n        "), _c('br'), _vm._v("\n        联系人secret:管理员进入企业微信管理后台后点击“客户联系”-“客户”页面。点开“API”小按钮，可以看到secret，此为外部联系人secret。\n      ")])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.editConfig(null)
      }
    }
  }, [_vm._v("添加企业微信")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "element-loading-text": "数据加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "企业名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "wx_corpid",
      "label": "企业ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "绑定时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.create_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "employee_secret",
      "label": "通讯录secret"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contact_secret",
      "label": "联系人管理secret"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "encoding_aes_key",
      "label": "加密串"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "event_callback",
      "label": "回调地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作："
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return undefined
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editVisible,
      "before-close": _vm.handleEdit
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [
    [_c('el-form', {
      ref: "form",
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.qyconfigForm,
        "label-width": "120px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "企业名称"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "企业名称"
      },
      model: {
        value: (_vm.qyconfigForm.name),
        callback: function($$v) {
          _vm.$set(_vm.qyconfigForm, "name", $$v)
        },
        expression: "qyconfigForm.name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "企业ID"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "企业ID"
      },
      model: {
        value: (_vm.qyconfigForm.corpid),
        callback: function($$v) {
          _vm.$set(_vm.qyconfigForm, "corpid", $$v)
        },
        expression: "qyconfigForm.corpid"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "通讯录secret"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "联系人管理secret"
      },
      model: {
        value: (_vm.qyconfigForm.employee_secret),
        callback: function($$v) {
          _vm.$set(_vm.qyconfigForm, "employee_secret", $$v)
        },
        expression: "qyconfigForm.employee_secret"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "联系人secret"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "联系人管理secret"
      },
      model: {
        value: (_vm.qyconfigForm.contact_secret),
        callback: function($$v) {
          _vm.$set(_vm.qyconfigForm, "contact_secret", $$v)
        },
        expression: "qyconfigForm.contact_secret"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "加密串"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "加密串"
      },
      model: {
        value: (_vm.qyconfigForm.encoding_aes_key),
        callback: function($$v) {
          _vm.$set(_vm.qyconfigForm, "encoding_aes_key", $$v)
        },
        expression: "qyconfigForm.encoding_aes_key"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "回调地址"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "回调地址"
      },
      model: {
        value: (_vm.qyconfigForm.event_callback),
        callback: function($$v) {
          _vm.$set(_vm.qyconfigForm, "event_callback", $$v)
        },
        expression: "qyconfigForm.event_callback"
      }
    })], 1)], 1)], _vm._v(" "), _c('div', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      nativeOn: {
        "click": function($event) {
          _vm.editCategroyVisible = false
        }
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.submitLoading
      },
      on: {
        "click": _vm.submitAction
      }
    }, [_vm._v(_vm._s(_vm.submitLoading ? '提交中' : '保存'))])], 1)
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-456da7c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-456da7c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/workwx/authorize/index.vue
// module id = 2677
// module chunks = 0